import { createTypedIntl, keyOf, type TranslationKey } from "@voltalis/frontend-tooling/i18n/runtime";

import { keys } from "@/.generated/i18n/i18n-keys.generated.ts";

export { keyOf, type TranslationKey };

export const useTypedIntl = createTypedIntl(keys);

export type TypedIntl = ReturnType<typeof useTypedIntl>;
